import * as types from "./types";

export const fetchingCircleCollections = () => ({
  type: types.FETCHING_CIRCLE_COLLECTIONS,
  loading: true
});

export const fetchedCircleCollections = circle_collections => ({
  type: types.FETCHED_CIRCLE_COLLECTIONS,
  list: circle_collections,
  loading: false
});

export const errorFetchingCircleCollections = error => ({
  type: types.ERROR_FETCHING_CIRCLE_COLLECTIONS,
  error: "errors.circle_collection.fetch",
  loading: false
});
